import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../../../core';
import {
  UsuarioPerfil,
  usuarioPerfilAdministrador,
} from '../../../home/usuario/usuario-perfil';

export const admin: UsuarioPerfil[] = [usuarioPerfilAdministrador];

@Injectable({
  providedIn: 'root'
})
export class OnlyAdminGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  canActivate(): boolean {
    if (this.authService.isAdministrador()) {
      return true;
    }

    this.router.navigate(['/acesso-negado']);
    return false;
  }
}
